export interface Chapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export interface Comic {
  id: string;
  title: string;
  slug: string;
  coverImage: string;
  category: string;
  author: string;
  artist: string;
  status: '连载中' | '已完结';
  updateDate: string;
  description: string;
  rating: number;
  views: number;
  tags: string[];
  chapters: Chapter[];
  featured?: boolean;
  isNew?: boolean;
}

export const comics: Comic[] = [
  {
    id: '1',
    title: '她的逆袭',
    slug: 'her-counterattack',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20elegant%20female%20protagonist%20in%20modern%20office%20setting%2C%20warm%20amber%20lighting%2C%20soft%20illustration%20style%2C%20clean%20white%20background%20with%20subtle%20gradient%2C%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    author: '金智秀',
    artist: '李恩在',
    status: '连载中',
    updateDate: '2026-08-04',
    description: '平凡女孩林小染在职场上屡遭排挤，但她凭借坚韧不拔的意志和过人的智慧一步步逆袭。当她遇到神秘上司韩辰宇后，两人从针锋相对到相互欣赏，一段甜蜜又励志的都市爱情故事就此展开。',
    rating: 9.2,
    views: 1580000,
    tags: ['职场', '逆袭', '甜宠', '都市'],
    chapters: [
      { id: 'ch1-1', title: '第1话 不被看见的努力', number: 1, date: '2026-06-15' },
      { id: 'ch1-2', title: '第2话 意外的邂逅', number: 2, date: '2026-06-22' },
      { id: 'ch1-3', title: '第3话 办公室风暴', number: 3, date: '2026-06-29' },
      { id: 'ch1-4', title: '第4话 深夜加班', number: 4, date: '2026-07-06' },
      { id: 'ch1-5', title: '第5话 他的秘密', number: 5, date: '2026-07-13' },
      { id: 'ch1-6', title: '第6话 重新出发', number: 6, date: '2026-07-20' },
      { id: 'ch1-7', title: '第7话 意外的盟友', number: 7, date: '2026-07-27' },
      { id: 'ch1-8', title: '第8话 心跳的距离', number: 8, date: '2026-08-03' },
    ],
    featured: true,
  },
  {
    id: '2',
    title: '魔法学徒的奇幻旅程',
    slug: 'magic-apprentice-journey',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20young%20magic%20apprentice%20holding%20a%20glowing%20staff%2C%20magical%20forest%20background%2C%20warm%20golden%20light%20particles%2C%20clean%20illustration%20style%2C%20digital%20webtoon%20art&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    author: '朴志勋',
    artist: '崔秀英',
    status: '连载中',
    updateDate: '2026-08-03',
    description: '普通高中生韩宇在一次意外中进入了魔法世界，成为了一名魔法学徒。在这个充满魔法与冒险的世界里，他将遇到各种奇妙的生物，学习强大的魔法，并揭开隐藏在自己身世背后的惊天秘密。',
    rating: 9.5,
    views: 2320000,
    tags: ['魔法', '冒险', '成长', '异世界'],
    chapters: [
      { id: 'ch2-1', title: '第1话 平凡的一天', number: 1, date: '2026-05-01' },
      { id: 'ch2-2', title: '第2话 通往异世界', number: 2, date: '2026-05-08' },
      { id: 'ch2-3', title: '第3话 魔法学院', number: 3, date: '2026-05-15' },
      { id: 'ch2-4', title: '第4话 第一次试炼', number: 4, date: '2026-05-22' },
      { id: 'ch2-5', title: '第5话 隐藏的力量', number: 5, date: '2026-05-29' },
      { id: 'ch2-6', title: '第6话 暗影来袭', number: 6, date: '2026-06-05' },
      { id: 'ch2-7', title: '第7话 龙之契约', number: 7, date: '2026-07-10' },
      { id: 'ch2-8', title: '第8话 决战前夕', number: 8, date: '2026-07-24' },
    ],
    featured: true,
  },
  {
    id: '3',
    title: '校园秘密',
    slug: 'campus-secrets',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%2C%20two%20students%20in%20school%20uniform%20standing%20under%20cherry%20blossom%20trees%2C%20spring%20atmosphere%2C%20soft%20warm%20lighting%2C%20clean%20illustration%2C%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'school',
    author: '郑多彬',
    artist: '尹智慧',
    status: '连载中',
    updateDate: '2026-08-02',
    description: '转学生苏瑶来到首尔一所高中，表面上看是一所普通的学校，却隐藏着一个不为人知的秘密社团。她和新朋友们一起揭开校园背后的神秘面纱，同时也在青春岁月中收获了真挚的友情与懵懂的爱情。',
    rating: 8.9,
    views: 980000,
    tags: ['青春', '校园', '秘密', '友情'],
    chapters: [
      { id: 'ch3-1', title: '第1话 转校生', number: 1, date: '2026-06-01' },
      { id: 'ch3-2', title: '第2话 神秘社团', number: 2, date: '2026-06-08' },
      { id: 'ch3-3', title: '第3话 地下图书馆', number: 3, date: '2026-06-15' },
      { id: 'ch3-4', title: '第4话 四个守护者', number: 4, date: '2026-06-22' },
      { id: 'ch3-5', title: '第5话 第一次任务', number: 5, date: '2026-06-29' },
      { id: 'ch3-6', title: '第6话 真相渐近', number: 6, date: '2026-07-06' },
    ],
  },
  {
    id: '4',
    title: '暗夜追踪者',
    slug: 'night-tracker',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20mysterious%20detective%20in%20dark%20alley%20at%20night%2C%20neon%20city%20lights%20reflecting%20on%20wet%20street%2C%20dramatic%20lighting%2C%20clean%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'action',
    author: '姜东元',
    artist: '宋慧乔',
    status: '已完结',
    updateDate: '2026-07-15',
    description: '前特种兵崔振宇退役后成为私家侦探，专门追踪那些警方无法触及的黑暗角落。一桩看似普通的失踪案，却牵扯出一个横跨国界的庞大犯罪网络。动作场面惊心动魄，推理环环相扣。',
    rating: 9.3,
    views: 1890000,
    tags: ['动作', '侦探', '犯罪', '悬疑'],
    chapters: [
      { id: 'ch4-1', title: '第1话 最后一案', number: 1, date: '2026-01-10' },
      { id: 'ch4-2', title: '第2话 暗夜降临', number: 2, date: '2026-01-17' },
      { id: 'ch4-3', title: '第3话 追踪', number: 3, date: '2026-01-24' },
      { id: 'ch4-4', title: '第4话 幕后黑手', number: 4, date: '2026-02-01' },
      { id: 'ch4-5', title: '第5话 最终对决', number: 5, date: '2026-02-15' },
      { id: 'ch4-6', title: '第6话 尾声', number: 6, date: '2026-03-01' },
    ],
  },
  {
    id: '5',
    title: '第十三个嫌疑人',
    slug: 'thirteenth-suspect',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%2C%20shadowy%20figure%20behind%20frosted%20glass%2C%20crime%20scene%20investigation%2C%20moody%20atmosphere%2C%20dark%20amber%20tones%2C%20clean%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'mystery',
    author: '张瑞元',
    artist: '金泰亨',
    status: '连载中',
    updateDate: '2026-08-01',
    description: '一栋豪华公寓中发生命案，12名住户都有不在场证明。但刑警李慧珍凭借敏锐直觉，发现了第13个嫌疑人的存在。随着调查深入，每个人的秘密被一层层剥开，真相远比想象中更加复杂。',
    rating: 9.1,
    views: 1120000,
    tags: ['推理', '悬疑', '犯罪', '心理'],
    chapters: [
      { id: 'ch5-1', title: '第1话 命案发生', number: 1, date: '2026-05-20' },
      { id: 'ch5-2', title: '第2话 十二人证词', number: 2, date: '2026-05-27' },
      { id: 'ch5-3', title: '第3话 时间裂缝', number: 3, date: '2026-06-03' },
      { id: 'ch5-4', title: '第4话 隐藏的房间', number: 4, date: '2026-06-10' },
      { id: 'ch5-5', title: '第5话 新的证据', number: 5, date: '2026-06-17' },
      { id: 'ch5-6', title: '第6话 拼图', number: 6, date: '2026-07-01' },
      { id: 'ch5-7', title: '第7话 第十三人', number: 7, date: '2026-07-15' },
    ],
  },
  {
    id: '6',
    title: '我的邻居是妖怪',
    slug: 'my-neighbor-monster',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20funny%20monster%20neighbor%20with%20human%20protagonist%2C%20bright%20colorful%20apartment%20setting%2C%20light%20humorous%20tone%2C%20warm%20cheerful%20illustration%2C%20digital%20webtoon%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'comedy',
    author: '刘在石',
    artist: '权志龙',
    status: '连载中',
    updateDate: '2026-08-03',
    description: '普通上班族金大宇搬进新公寓，却发现隔壁邻居竟然是来自深山的妖怪！更要命的是，这只妖怪还超级自来熟，天天串门蹭饭、帮忙（添乱）。一段笑料百出的跨种族同居生活就此展开！',
    rating: 9.0,
    views: 1450000,
    tags: ['搞笑', '日常', '妖怪', '治愈'],
    chapters: [
      { id: 'ch6-1', title: '第1话 新邻居', number: 1, date: '2026-04-01' },
      { id: 'ch6-2', title: '第2话 深夜访客', number: 2, date: '2026-04-08' },
      { id: 'ch6-3', title: '第3话 妖怪的早餐', number: 3, date: '2026-04-15' },
      { id: 'ch6-4', title: '第4话 一起上班', number: 4, date: '2026-04-22' },
      { id: 'ch6-5', title: '第5话 妖怪的烦恼', number: 5, date: '2026-05-01' },
      { id: 'ch6-6', title: '第6话 人类世界大冒险', number: 6, date: '2026-05-15' },
      { id: 'ch6-7', title: '第7话 妖怪的朋友们', number: 7, date: '2026-06-01' },
      { id: 'ch6-8', title: '第8话 夏日祭典', number: 8, date: '2026-07-01' },
    ],
    isNew: true,
  },
  {
    id: '7',
    title: '重生之商业帝国',
    slug: 'rebirth-business-empire',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20confident%20businessman%20in%20modern%20office%20with%20city%20skyline%20view%2C%20sophisticated%20warm%20amber%20lighting%2C%20clean%20professional%20illustration%2C%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'drama',
    author: '李明博',
    artist: '朴宝剑',
    status: '已完结',
    updateDate: '2026-06-30',
    description: '商业天才陈浩在45岁时被最信任的伙伴背叛，含恨而终。意外重生回到20岁的他，带着前世的记忆和商业智慧，决心打造一个无人能撼动的商业帝国，同时也要找到前世的真相。',
    rating: 9.6,
    views: 2870000,
    tags: ['重生', '商战', '复仇', '爽文'],
    chapters: [
      { id: 'ch7-1', title: '第1话 背叛', number: 1, date: '2026-01-05' },
      { id: 'ch7-2', title: '第2话 重生', number: 2, date: '2026-01-12' },
      { id: 'ch7-3', title: '第3话 第一桶金', number: 3, date: '2026-01-19' },
      { id: 'ch7-4', title: '第4话 棋局开始', number: 4, date: '2026-02-01' },
      { id: 'ch7-5', title: '第5话 商业对决', number: 5, date: '2026-02-15' },
      { id: 'ch7-6', title: '第6话 真相浮现', number: 6, date: '2026-03-01' },
      { id: 'ch7-7', title: '第7话 巅峰之战', number: 7, date: '2026-03-20' },
      { id: 'ch7-8', title: '第8话 新帝国', number: 8, date: '2026-04-10' },
    ],
    featured: true,
    isNew: true,
  },
  {
    id: '8',
    title: '甜蜜陷阱',
    slug: 'sweet-trap',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20couple%20in%20cafe%20with%20warm%20lighting%2C%20pastry%20and%20coffee%2C%20soft%20romantic%20atmosphere%2C%20gentle%20warm%20tones%2C%20clean%20illustration%20digital%20webtoon%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'romance',
    author: '韩素希',
    artist: '李敏镐',
    status: '连载中',
    updateDate: '2026-08-04',
    description: '甜品师尹舒雅开了一家小小的蛋糕店，本想过着平静的生活。谁知隔壁咖啡店的老板郑宇成不仅抢生意，还总是对她露出意味深长的微笑。当甜蜜的蛋糕遇上苦涩的咖啡，会碰撞出怎样的火花？',
    rating: 8.8,
    views: 890000,
    tags: ['甜品', '恋爱', '治愈', '美食'],
    chapters: [
      { id: 'ch8-1', title: '第1话 新店开张', number: 1, date: '2026-05-10' },
      { id: 'ch8-2', title: '第2话 隔壁的对手', number: 2, date: '2026-05-17' },
      { id: 'ch8-3', title: '第3话 提拉米苏的秘密', number: 3, date: '2026-05-24' },
      { id: 'ch8-4', title: '第4话 雨天的访客', number: 4, date: '2026-06-01' },
      { id: 'ch8-5', title: '第5话 心跳的温度', number: 5, date: '2026-06-15' },
      { id: 'ch8-6', title: '第6话 告白', number: 6, date: '2026-07-01' },
    ],
  },
  {
    id: '9',
    title: '异世界食堂',
    slug: 'isekai-diner',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20food%20cover%2C%20magical%20restaurant%20with%20floating%20dishes%2C%20fantasy%20creatures%20as%20customers%2C%20warm%20golden%20interior%20lighting%2C%20cozy%20atmosphere%2C%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'fantasy',
    author: '文在寅',
    artist: '孙艺珍',
    status: '连载中',
    updateDate: '2026-08-02',
    description: '米其林三星主厨金贤宇意外穿越到异世界，在这个没有美食概念的世界开了一家食堂。精灵、矮人、龙族纷纷被他的料理征服，而他也通过美食结交了一群奇妙的异世界朋友。',
    rating: 9.4,
    views: 1760000,
    tags: ['美食', '异世界', '温馨', '冒险'],
    chapters: [
      { id: 'ch9-1', title: '第1话 穿越', number: 1, date: '2026-04-15' },
      { id: 'ch9-2', title: '第2话 第一个客人', number: 2, date: '2026-04-22' },
      { id: 'ch9-3', title: '第3话 精灵的赞美', number: 3, date: '2026-04-29' },
      { id: 'ch9-4', title: '第4话 龙的挑战', number: 4, date: '2026-05-06' },
      { id: 'ch9-5', title: '第5话 美食节', number: 5, date: '2026-05-20' },
      { id: 'ch9-6', title: '第6话 王都之行', number: 6, date: '2026-06-10' },
      { id: 'ch9-7', title: '第7话 皇家盛宴', number: 7, date: '2026-07-01' },
    ],
    isNew: true,
  },
  {
    id: '10',
    title: '放学后的钢琴室',
    slug: 'after-school-piano',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20music%20cover%2C%20girl%20playing%20piano%20in%20sunlit%20school%20music%20room%2C%20warm%20afternoon%20light%2C%20dust%20particles%20floating%2C%20nostalgic%20atmosphere%2C%20clean%20digital%20webtoon%20art&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'school',
    author: '全智贤',
    artist: '金秀贤',
    status: '连载中',
    updateDate: '2026-08-01',
    description: '内向的钢琴天才林智恩每天放学后都会独自在音乐教室练琴。某天，她遇到了同样热爱音乐但性格截然不同的转学生朴灿烈。两个灵魂在琴声中相遇，谱写出一段动人的青春华章。',
    rating: 9.0,
    views: 1060000,
    tags: ['音乐', '青春', '治愈', '成长'],
    chapters: [
      { id: 'ch10-1', title: '第1话 孤独的琴声', number: 1, date: '2026-05-05' },
      { id: 'ch10-2', title: '第2话 转学生', number: 2, date: '2026-05-12' },
      { id: 'ch10-3', title: '第3话 合奏', number: 3, date: '2026-05-19' },
      { id: 'ch10-4', title: '第4话 比赛前夕', number: 4, date: '2026-06-02' },
      { id: 'ch10-5', title: '第5话 舞台之上', number: 5, date: '2026-06-16' },
      { id: 'ch10-6', title: '第6话 新的乐章', number: 6, date: '2026-07-01' },
    ],
  },
  {
    id: '11',
    title: '剑与魔法',
    slug: 'sword-and-magic',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20cover%2C%20warrior%20wielding%20flaming%20sword%20against%20dark%20dragon%2C%20epic%20battle%20scene%2C%20dramatic%20lighting%20with%20golden%20amber%20sparks%2C%20clean%20digital%20webtoon%20art&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'action',
    author: '崔岷植',
    artist: '河正宇',
    status: '连载中',
    updateDate: '2026-08-04',
    description: '在剑与魔法并存的大陆，少年剑士李昊然踏上寻找传说圣剑的旅途。他需要击败黑暗势力的爪牙，解开远古遗迹的谜题，并在旅途中结识志同道合的伙伴，共同守护大陆的和平。',
    rating: 9.3,
    views: 2050000,
    tags: ['剑术', '魔法', '冒险', '史诗'],
    chapters: [
      { id: 'ch11-1', title: '第1话 启程', number: 1, date: '2026-03-01' },
      { id: 'ch11-2', title: '第2话 初次战斗', number: 2, date: '2026-03-08' },
      { id: 'ch11-3', title: '第3话 魔法师', number: 3, date: '2026-03-15' },
      { id: 'ch11-4', title: '第4话 暗影森林', number: 4, date: '2026-03-22' },
      { id: 'ch11-5', title: '第5话 遗迹之谜', number: 5, date: '2026-04-01' },
      { id: 'ch11-6', title: '第6话 龙之谷', number: 6, date: '2026-04-15' },
      { id: 'ch11-7', title: '第7话 圣剑觉醒', number: 7, date: '2026-05-01' },
      { id: 'ch11-8', title: '第8话 黑暗军团', number: 8, date: '2026-06-01' },
    ],
    featured: true,
  },
  {
    id: '12',
    title: '密室逃脱',
    slug: 'escape-room',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20escape%20room%20cover%2C%20group%20of%20people%20in%20locked%20room%20with%20puzzles%2C%20tense%20atmosphere%2C%20dim%20warm%20lighting%2C%20suspenseful%20mood%2C%20clean%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'mystery',
    author: '罗英锡',
    artist: '申东烨',
    status: '已完结',
    updateDate: '2026-07-20',
    description: '六名陌生人醒来后发现被困在一个密闭空间，他们必须通过一连串的谜题和挑战才能逃脱。但随着时间的推移，他们发现这场"游戏"背后隐藏着一个与他们每个人都相关的惊天秘密。',
    rating: 9.1,
    views: 1340000,
    tags: ['密室', '解谜', '生存', '反转'],
    chapters: [
      { id: 'ch12-1', title: '第1话 醒来', number: 1, date: '2026-02-10' },
      { id: 'ch12-2', title: '第2话 规则', number: 2, date: '2026-02-17' },
      { id: 'ch12-3', title: '第3话 第一道谜题', number: 3, date: '2026-02-24' },
      { id: 'ch12-4', title: '第4话 分歧', number: 4, date: '2026-03-05' },
      { id: 'ch12-5', title: '第5话 背叛', number: 5, date: '2026-03-15' },
      { id: 'ch12-6', title: '第6话 真相', number: 6, date: '2026-04-01' },
      { id: 'ch12-7', title: '第7话 自由', number: 7, date: '2026-04-20' },
    ],
  },
  {
    id: '13',
    title: '废柴逆袭记',
    slug: 'loser-counterattack',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%2C%20funny%20underdog%20character%20transforming%20into%20hero%2C%20bright%20colorful%20comic%20panels%2C%20humorous%20exaggerated%20expressions%2C%20warm%20cheerful%20illustration%2C%20digital%20webtoon%20style&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    category: 'comedy',
    author: '姜虎东',
    artist: '李秀根',
    status: '连载中',
    updateDate: '2026-08-03',
    description: '30岁的无业游民朴正洙被家人扫地出门后，阴差阳错进入了一家顶级游戏公司。在这里，他这个"废柴"大叔要和一群天才少年一起开发游戏，闹出了无数笑话，却也意外找到了人生的方向。',
    rating: 8.7,
    views: 780000,
    tags: ['搞笑', '励志', '游戏', '职场'],
    chapters: [
      { id: 'ch13-1', title: '第1话 被赶出家门', number: 1, date: '2026-04-10' },
      { id: 'ch13-2', title: '第2话 面试乌龙', number: 2, date: '2026-04-17' },
      { id: 'ch13-3', title: '第3话 天才同事们', number: 3, date: '2026-04-24' },
      { id: 'ch13-4', title: '第4话 第一个项目', number: 4, date: '2026-05-08' },
      { id: 'ch13-5', title: '第5话 菜鸟的逆袭', number: 5, date: '2026-05-22' },
    ],
    isNew: true,
  },
  {
    id: '14',
    title: '皇室的秘密',
    slug: 'royal-secret',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20cover%2C%20princess%20in%20traditional%20hanbok%20in%20ancient%20palace%2C%20golden%20warm%20lighting%2C%20elegant%20royal%20setting%2C%20dramatic%20atmosphere%2C%20clean%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    category: 'drama',
    author: '金惠秀',
    artist: '赵寅成',
    status: '已完结',
    updateDate: '2026-07-10',
    description: '朝鲜王朝时期，宫女素月被秘密送入宫中执行一项任务——揭开先王驾崩的真相。在宫墙之内，她发现了皇室隐藏百年的秘密，这个秘密一旦曝光，将彻底颠覆整个王朝的命运。',
    rating: 9.5,
    views: 2200000,
    tags: ['历史', '宫廷', '权谋', '爱情'],
    chapters: [
      { id: 'ch14-1', title: '第1话 入宫', number: 1, date: '2025-12-01' },
      { id: 'ch14-2', title: '第2话 宫中的眼睛', number: 2, date: '2025-12-15' },
      { id: 'ch14-3', title: '第3话 密信', number: 3, date: '2026-01-01' },
      { id: 'ch14-4', title: '第4话 世子', number: 4, date: '2026-01-15' },
      { id: 'ch14-5', title: '第5话 深夜密谈', number: 5, date: '2026-02-01' },
      { id: 'ch14-6', title: '第6话 真相浮现', number: 6, date: '2026-02-20' },
      { id: 'ch14-7', title: '第7话 抉择', number: 7, date: '2026-03-10' },
      { id: 'ch14-8', title: '第8话 新的时代', number: 8, date: '2026-04-01' },
    ],
  },
  {
    id: '15',
    title: '初恋这件小事',
    slug: 'first-love',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20youth%20cover%2C%20young%20couple%20on%20bicycle%20in%20summer%20countryside%2C%20golden%20hour%20sunlight%2C%20nostalgic%20warm%20atmosphere%2C%20soft%20romantic%20illustration%2C%20digital%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    category: 'romance',
    author: '宋慧乔',
    artist: '宋仲基',
    status: '连载中',
    updateDate: '2026-08-03',
    description: '高中三年级的夏天，乖乖女李恩珠遇到了隔壁班的痞子学霸崔泰俊。两个看似毫无交集的人，却因为一次意外的补课而渐渐走近。青涩的初恋，是每个人心中最柔软的角落。',
    rating: 9.2,
    views: 1650000,
    tags: ['初恋', '校园', '青春', '成长'],
    chapters: [
      { id: 'ch15-1', title: '第1话 夏天来了', number: 1, date: '2026-05-15' },
      { id: 'ch15-2', title: '第2话 隔壁班的他', number: 2, date: '2026-05-22' },
      { id: 'ch15-3', title: '第3话 补课约定', number: 3, date: '2026-05-29' },
      { id: 'ch15-4', title: '第4话 图书馆的秘密', number: 4, date: '2026-06-05' },
      { id: 'ch15-5', title: '第5话 心跳', number: 5, date: '2026-06-12' },
      { id: 'ch15-6', title: '第6话 花火大会', number: 6, date: '2026-06-26' },
      { id: 'ch15-7', title: '第7话 告白', number: 7, date: '2026-07-10' },
    ],
  },
];